/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRequestRequestBody,
  CreateRequestRequestBody$Outbound,
  CreateRequestRequestBody$outboundSchema,
} from "../components/createrequestrequestbody.js";

export type CreateMcpApprovalRequestSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateMcpApprovalRequestRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRequestRequestBody: CreateRequestRequestBody;
};

/** @internal */
export type CreateMcpApprovalRequestSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateMcpApprovalRequestSecurity$outboundSchema: z.ZodMiniType<
  CreateMcpApprovalRequestSecurity$Outbound,
  CreateMcpApprovalRequestSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createMcpApprovalRequestSecurityToJSON(
  createMcpApprovalRequestSecurity: CreateMcpApprovalRequestSecurity,
): string {
  return JSON.stringify(
    CreateMcpApprovalRequestSecurity$outboundSchema.parse(
      createMcpApprovalRequestSecurity,
    ),
  );
}

/** @internal */
export type CreateMcpApprovalRequestRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRequestRequestBody: CreateRequestRequestBody$Outbound;
};

/** @internal */
export const CreateMcpApprovalRequestRequest$outboundSchema: z.ZodMiniType<
  CreateMcpApprovalRequestRequest$Outbound,
  CreateMcpApprovalRequestRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRequestRequestBody: CreateRequestRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createRequestRequestBody: "CreateRequestRequestBody",
    });
  }),
);

export function createMcpApprovalRequestRequestToJSON(
  createMcpApprovalRequestRequest: CreateMcpApprovalRequestRequest,
): string {
  return JSON.stringify(
    CreateMcpApprovalRequestRequest$outboundSchema.parse(
      createMcpApprovalRequestRequest,
    ),
  );
}
